/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/shareable_preview" endpoint
 */
import fetch from "@lib/fetch";

import { engagementAppGroupIdShareablePreviewCacheKeys } from "../engagementAppGroupIdShareablePreviewGetLinks/constants";
import type { EngagementAppGroupIdShareablePreviewResult } from "../engagementAppGroupIdShareablePreviewGetLinks";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostEngagementAppGroupIdShareablePreviewProps,
  PostShareablePreviewDomExtractionProps,
} from "./types";

const isDomExtractionRequest = (
  props: PostEngagementAppGroupIdShareablePreviewProps
): props is PostShareablePreviewDomExtractionProps => "html" in props && !("message" in props);

export const postEngagementAppGroupIdShareablePreviewLink = reactQueryMutationAdapter(
  engagementAppGroupIdShareablePreviewCacheKeys,
  (props: PostEngagementAppGroupIdShareablePreviewProps): Promise<EngagementAppGroupIdShareablePreviewResult> => {
    if (isDomExtractionRequest(props)) {
      return fetch(`/engagement/${props.appGroupId}/shareable_preview`, "POST", {
        app_group_id: props.appGroupId,
        context_id: props.contextId,
        html: props.html,
      });
    }

    return fetch(`/engagement/${props.appGroupId}/shareable_preview`, "POST", {
      app_group_id: props.appGroupId,
      context_id: props.contextId,
      is_workflow_step: props.is_workflow_step,
      link_config_set: props.link_config_set,
      container_size: props.container_size,
      message: props.message,
      random_user: props.random_user,
      custom_user_hash: props.custom_user_hash,
      trigger_properties_hash: props.trigger_properties_hash,
      user_id: props.user_id,
      component_store: props.component_store,
    });
  }
);
